// Zone catalog
export const FETCH_ZONES = 'PARKING_ZONES/FETCH_ZONES';
export const FETCH_ZONES_SUCCESS = 'PARKING_ZONES/FETCH_ZONES_SUCCESS';
export const FETCH_ZONES_ERROR = 'PARKING_ZONES/FETCH_ZONES_ERROR';

export const FETCH_ZONE_BY_ID = 'PARKING_ZONES/FETCH_ZONE_BY_ID';
export const FETCH_ZONE_BY_ID_SUCCESS = 'PARKING_ZONES/FETCH_ZONE_BY_ID_SUCCESS';
export const FETCH_ZONE_BY_ID_ERROR = 'PARKING_ZONES/FETCH_ZONE_BY_ID_ERROR';

export const CREATE_ZONE = 'PARKING_ZONES/CREATE_ZONE';
export const CREATE_ZONE_SUCCESS = 'PARKING_ZONES/CREATE_ZONE_SUCCESS';
export const CREATE_ZONE_ERROR = 'PARKING_ZONES/CREATE_ZONE_ERROR';

export const UPDATE_ZONE = 'PARKING_ZONES/UPDATE_ZONE';
export const UPDATE_ZONE_SUCCESS = 'PARKING_ZONES/UPDATE_ZONE_SUCCESS';
export const UPDATE_ZONE_ERROR = 'PARKING_ZONES/UPDATE_ZONE_ERROR';

export const DELETE_ZONE = 'PARKING_ZONES/DELETE_ZONE';
export const DELETE_ZONE_SUCCESS = 'PARKING_ZONES/DELETE_ZONE_SUCCESS';
export const DELETE_ZONE_ERROR = 'PARKING_ZONES/DELETE_ZONE_ERROR';

// Lots that use a given zone
export const FETCH_ZONE_LOTS = 'PARKING_ZONES/FETCH_ZONE_LOTS';
export const FETCH_ZONE_LOTS_SUCCESS = 'PARKING_ZONES/FETCH_ZONE_LOTS_SUCCESS';
export const FETCH_ZONE_LOTS_ERROR = 'PARKING_ZONES/FETCH_ZONE_LOTS_ERROR';

// Zones attached to a specific lot
export const FETCH_LOT_ZONES = 'PARKING_ZONES/FETCH_LOT_ZONES';
export const FETCH_LOT_ZONES_SUCCESS = 'PARKING_ZONES/FETCH_LOT_ZONES_SUCCESS';
export const FETCH_LOT_ZONES_ERROR = 'PARKING_ZONES/FETCH_LOT_ZONES_ERROR';

// Attach / unlink zone to/from a lot
export const ATTACH_ZONE_TO_LOT = 'PARKING_ZONES/ATTACH_ZONE_TO_LOT';
export const ATTACH_ZONE_TO_LOT_SUCCESS = 'PARKING_ZONES/ATTACH_ZONE_TO_LOT_SUCCESS';
export const ATTACH_ZONE_TO_LOT_ERROR = 'PARKING_ZONES/ATTACH_ZONE_TO_LOT_ERROR';

export const UNLINK_ZONE_FROM_LOT = 'PARKING_ZONES/UNLINK_ZONE_FROM_LOT';
export const UNLINK_ZONE_FROM_LOT_SUCCESS = 'PARKING_ZONES/UNLINK_ZONE_FROM_LOT_SUCCESS';
export const UNLINK_ZONE_FROM_LOT_ERROR = 'PARKING_ZONES/UNLINK_ZONE_FROM_LOT_ERROR';
